import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext({});

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);

    useEffect(() => {
        const savedToken = localStorage.getItem('asg_admin_token');
        const savedUser = localStorage.getItem('asg_admin_user');
        if (savedToken && savedUser) {
            setToken(savedToken);
            try {
                setUser(JSON.parse(savedUser));
            } catch (e) {
                localStorage.removeItem('asg_admin_token');
                localStorage.removeItem('asg_admin_user');
            }
        }
    }, []);

    const login = (tokenValue, userData) => {
        localStorage.setItem('asg_admin_token', tokenValue);
        localStorage.setItem('asg_admin_user', JSON.stringify(userData));
        setToken(tokenValue);
        setUser(userData);
    };

    const logout = () => {
        localStorage.removeItem('asg_admin_token');
        localStorage.removeItem('asg_admin_user');
        setToken(null);
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, token, login, logout, isAuthenticated: !!token }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
